module.exports = __webpack_public_path__ + "img/logo-and-text.11de8e15.png";